import React from 'react';
import { Form, Input, Checkbox } from 'antd';

const InputGroup = Input.Group;

export default function Footer(props) {
    return (
        <div className="row">

            <div className="col-md-9 pt-10">
            </div>

            <div className="col-md-3 pt-10">

                <div className="col text-right mb-5">
                    <div className="total-inline">
                        <label>Monto Total</label>
                        <div>{props.formValues.Monto.toFixed(2)}</div>
                    </div>
                </div>

                <div className="col text-right mb-5">
                    <div className="total-inline">
                        <label>Importe Cancelado</label>
                        <div>{props.formValues.ImporteCancelado.toFixed(2)}</div>
                    </div>
                </div>
                <div className="col text-right mb-5">
                    <div className="total-inline">
                        <label>Saldo Pendiente</label>
                        <div>{props.formValues.Saldo.toFixed(2)}</div>
                    </div>
                </div>

            </div>
        </div>
    );
}